import { render, staticRenderFns } from "./UserTransaction.vue?vue&type=template&id=61a47a7f&scoped=true"
import script from "./UserTransaction.vue?vue&type=script&lang=js"
export * from "./UserTransaction.vue?vue&type=script&lang=js"
import style0 from "./UserTransaction.vue?vue&type=style&index=0&id=61a47a7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a47a7f",
  null
  
)

export default component.exports